import requests from "./httpService";

const RoleServices = {

  addRole: async (body) => {
    return requests.post("/profile/add", body);
  },
  getAllRole: async (body) => {
    return requests.get("/profile/", body);
  },
  getRoleById: async (id, body) => {
    return requests.get(`/profile/${id}`, body);
  },

  updateRole: async (id, body) => {
    return requests.put(`/profile/update/${id}`, body);
  },

  deleteRole: async (id) => {
    return requests.delete(`/profile/delete/${id}`);
  },
 
};

export default RoleServices;
